import { find } from 'lodash';

import SelectInput from './SelectInput';
import { EmailTemplateType, emailTemplateTypeLabels } from '../../../types';

import type { ActionMeta, OnChangeValue } from 'react-select/dist/declarations/src/types';
import type { CreatableEmailTemplateType } from '../../../types';
import type { ReactNode } from 'react';

export interface Option {
  value: `${CreatableEmailTemplateType}`;
  label: string;
}

const options: Option[] = [{
  value: EmailTemplateType.AvailabilityRequestEmail,
  label: emailTemplateTypeLabels[EmailTemplateType.AvailabilityRequestEmail],
}, {
  value: EmailTemplateType.ConfirmationEmail,
  label: emailTemplateTypeLabels[EmailTemplateType.ConfirmationEmail],
}, {
  value: EmailTemplateType.SelfSchedulingRequestEmail,
  label: emailTemplateTypeLabels[EmailTemplateType.SelfSchedulingRequestEmail],
}];

interface Props {
  className?: string;
  helperText?: ReactNode;
  isDisabled?: boolean;
  onChange: (newValue: OnChangeValue<Option, false>, actionMeta: ActionMeta<Option>) => void;
  value?: `${CreatableEmailTemplateType}`;
}

const EmailTemplateTypeSelectInput = ({ className, helperText, isDisabled = false, onChange, value }: Props) => (
  <SelectInput
    className={className}
    helperText={helperText}
    isDisabled={isDisabled}
    isRequired
    label="Template Type"
    onChange={onChange}
    options={options}
    placeholder="Select a template type"
    value={value ? find(options, ['value', value]) : null}
  />
);

export default EmailTemplateTypeSelectInput;
